import styled from '@emotion/styled';
import {
	FixedGridItem,
	getIconLinkHoverStyle,
	ITheme,
	StyledCardLink,
} from '../../../../../../ui';
import themed from '../../../../../../ui/themer/themed';

export const StyledMyBookingCard = styled(FixedGridItem)<{}, ITheme>`
	box-shadow: ${themed(({ card }) => card.fullyClickable.boxShadow)};

	${StyledCardLink} {
		font-weight: normal;
	}

	&:hover {
		box-shadow: ${themed(({ card }) => card.fullyClickable.hover.boxShadow)};
		cursor: pointer;

		${StyledCardLink} {
			${getIconLinkHoverStyle};
		}
	}

	hr {
		margin: 0 24px;
	}
`;

export const StyledMyBookingCardRow = styled.div<{}, ITheme>`
	padding: 24px;
	font-weight: 700;
`;

export const StyledMyBookingCardTopRow = styled(StyledMyBookingCardRow)<
	{},
	ITheme
>`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const StyledMyBookingCardTitleRow = styled(StyledMyBookingCardRow)<
	{},
	ITheme
>`
	background: ${themed(({ background }) => background.light)};
`;
